export const AssignmentSections = {
    HOME: 'home',
    PATTERNS: 'patterns',
    COMPONENTS: 'components',
    QUESTIONS: 'questions',
    UNIT_TESTS: 'unitTests',
    REPORTS: {
        SUMMARY: 'summary',
        PATTERNS: 'patterns-report',
        FEEDBACK_FROM_STUDENTS: 'feedback-by-students',
        ANALYTICS: 'analytics',
    },
    SNIPPETS: 'snippets',
    INSTANT_FEEDBACK: 'instantFeedback',
    TOOLS: 'tools',
    DISCOVERY_DESCRIPTIONS_REVIEW: 'discovery-descriptions-review',
    IMPORT_RUBRIC: 'import-rubric',
    RUBRIC: 'rubric',
    RUBRIC_REFINEMENT: 'rubric-refinement',
    RUBRICS_MANAGEMENT: 'rubrics',
}
